(function(){
  function debounce(fn, wait){
    var t;
    return function(){
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function(){ fn.apply(ctx, args); }, wait);
    };
  }

  function realSectionId(el){
    var wrap = el && el.closest('.shopify-section');
    if (!wrap || !wrap.id) return null;
    return wrap.id.replace(/^shopify-section-/, '');
  }

  function refreshSection(sectionId, targetSelector, freshSelector){
    var url = window.location.pathname + '?section_id=' + encodeURIComponent(sectionId);
    return fetch(url, { credentials: 'same-origin' })
      .then(function(r){ return r.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector(freshSelector || targetSelector);
        var current = document.querySelector(targetSelector);
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
          return true;
        }
        return false;
      })
      .catch(function(){ return false; });
  }

  function refreshCart(){
    var jobs = [];
    var seen = {};

    function queue(el, targetSelector, freshSelector){
      if (!el) return;
      var sid = realSectionId(el);
      if (!sid) return;
      var key = sid + '|' + targetSelector;
      if (seen[key]) return;
      seen[key] = true;
      jobs.push(refreshSection(sid, targetSelector, freshSelector));
    }

    // Cart drawer: one section covers heading item-count, line items, subtotal, and savings
    queue(document.querySelector('cart-drawer'), 'cart-drawer', 'cart-drawer');

    // Classic /cart page: items list + footer (subtotal) are separate sections
    queue(document.getElementById('main-cart-items'), 'cart-items, #main-cart-items', 'cart-items, #main-cart-items');
    queue(document.getElementById('main-cart-footer'), '#main-cart-footer', '#main-cart-footer');

    // Header cart icon bubble (item count badge) lives inside the header section
    queue(document.getElementById('cart-icon-bubble'), '#cart-icon-bubble', '#cart-icon-bubble');

    return Promise.all(jobs);
  }

  function postChange(line, quantity){
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function(r){
      if (!r.ok) throw new Error('cart/change failed: ' + r.status);
      return r.json();
    });
  }

  function findRow(el){
    return el.closest('.cart-item') || el.closest('li[id^="CartDrawer-Item-"]') || el.closest('[id^="CartItem-"]');
  }

  function findIndex(el){
    var withData = el.closest('[data-index]');
    return withData ? withData.dataset.index : null;
  }

  function handleError(err, row){
    console.error('[cart-live-update]', err);
    if (row) { row.style.opacity = '1'; row.style.pointerEvents = ''; }
    window.location.reload();
  }

  // ---- Remove (trash icon) ----
  function handleRemoveClick(e){
    var btn = e.target.closest('cart-remove-button');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var row = findRow(btn);
    var index = btn.dataset.index || findIndex(btn);
    if (!index) return;

    if (row) {
      row.style.transition = 'opacity 0.15s ease';
      row.style.opacity = '0.35';
      row.style.pointerEvents = 'none';
    }

    postChange(index, 0)
      .then(function(){ return refreshCart(); })
      .then(function(){ if (row && row.isConnected) row.remove(); })
      .catch(function(err){ handleError(err, row); });
  }

  // ---- Quantity +/- buttons ----
  function handleQuantityClick(e){
    var btn = e.target.closest('.quantity__button');
    if (!btn) return;
    var wrapper = btn.closest('quantity-input');
    if (!wrapper) return;
    var input = wrapper.querySelector('input.quantity__input');
    if (!input) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var min = parseInt(input.min || '0', 10);
    if (isNaN(min)) min = 0;
    var step = parseInt(input.step || '1', 10);
    if (isNaN(step) || step < 1) step = 1;
    var current = parseInt(input.value || '0', 10);
    if (isNaN(current)) current = 0;
    var next = btn.name === 'plus' ? current + step : current - step;
    if (next < min) next = min;

    input.value = next;

    var index = input.dataset.index || findIndex(input);
    if (!index) return;

    var row = findRow(input);
    if (row) row.style.opacity = '0.6';

    postChange(index, next)
      .then(function(){ return refreshCart(); })
      .then(function(){ if (row) row.style.opacity = '1'; })
      .catch(function(err){ handleError(err, row); });
  }

  // ---- Quantity typed directly ----
  var handleQuantityChange = debounce(function(e){
    var input = e.target;
    if (!input.matches || !input.matches('input.quantity__input')) return;
    var index = input.dataset.index || findIndex(input);
    if (!index) return;
    var qty = parseInt(input.value || '0', 10);
    if (isNaN(qty) || qty < 0) return;
    var row = findRow(input);
    postChange(index, qty).then(function(){ return refreshCart(); }).catch(function(err){ handleError(err, row); });
  }, 500);

  function handleQuantityChangeCapture(e){
    if (e.target.matches && e.target.matches('input.quantity__input')) {
      e.stopImmediatePropagation();
      handleQuantityChange(e);
    }
  }

  document.addEventListener('click', handleRemoveClick, true);
  document.addEventListener('click', handleQuantityClick, true);
  document.addEventListener('change', handleQuantityChangeCapture, true);
})();
